
// TOP BAR SOCIAL LINKS
export const topbarSocialLinks = {
  facebook: "https://www.facebook.com/",
  twitter: "https://twitter.com/",
  instagram: "https://www.instagram.com/"
};


// TOP BAR LANGUAGE OPTIONS
export const languageOptions = {
  en: {
    title: "EN",
    value: "en"
  },
  es: {
    title: "DE",
    value: "de"
  }
};


// MOBILE NAVIGATION LIST
export const mobileNavigation = [{
  title: "Inicio",
  icon: "Home",
  href: "/",
  badge: false
}, {
  title: "Carrito",
  icon: "ShoppingBagOutlined",
  href: "/cart",
  badge: true
}, {
  title: "Mi cuenta",
  icon: "User2",
  href: "/profile",
  badge: false
}];


// MOBILE NAVIGATION LIST
export const mobileNavigationTwo = [{
  title: "Home",
  icon: "Home",
  href: "/",
  badge: false
}, {
  title: "Category",
  icon: "CategoryOutlined",
  href: "",
  badge: false
}, {
  title: "Cart",
  icon: "ShoppingBagOutlined",
  href: "/cart",
  badge: true
}, {
  title: "Account",
  icon: "User2",
  href: "/profile",
  badge: false
}];


// CATEGORY LIST FOR HEADER
export const categories = [{
  title: "Productos",
  value: "product"
}, {
  title: "Vendedores",
  value: "seller"
}, ];


// SIDEBAR FOOTER LINKS
export const footerLinks = [{
  title: "Terms",
  url: "/"
}, {
  title: "Privacy",
  url: "/"
}, {
  title: "Help",
  url: "/"
}];
export const footerAboutLinks = [{
  title: "Careers",
  url: "#"
}, {
  title: "Our Stores",
  url: "#"
}, {
  title: "Our Cares",
  url: "#"
}, {
  title: "Terms & Conditions",
  url: "#"
}, {
  title: "Privacy Policy",
  url: "#"
}];
export const footerCustomerCareLinks = [{
  title: "Help Center",
  url: "#"
}, {
  title: "Track Your Order",
  url: "#"
}, {
  title: "Corporate & Bulk Purchasing",
  url: "#"
}, {
  title: "Returns & Refunds",
  url: "#"
}];
export const footerSocialLinks = {
  facebook: "https://www.facebook.com/",
  twitter: "https://twitter.com/",
  instagram: "https://www.instagram.com/",
  youtube: "https://www.instagram.com/",
  google: "https://www.instagram.com/"
};
export const footerDescription = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor libero id et, in gravida. Sit diam duis mauris nulla cursus. Erat et lectus vel ut sollicitudin elit at amet.";
export const footerContact = {
  phone: "+1 1123 456 780",
  email: "uilib.help@gmail.com",
  address: "70 Washington Square South, New York, NY 10012, United States"
};